import { GatewayStatus } from '@/models/gateway-status'

export class GatewayDetails{
  status?: GatewayStatus;
  statusUpdatedTime?: string;

  constructor(params?: Partial<GatewayDetails>) {
    Object.assign(this, params);
  }
}
